import { PIPE } from './constants';
import processPipe from './processPipe';

function getPipeValue(pipeString, fieldName) {
  if (!pipeString) {
    return null;
  }
  if (typeof pipeString !== 'string') {
    throw new TypeError(`getPipeValue expects a string. Got ${typeof pipeString}`);
  }

  const type = typeof fieldName;
  if (type !== 'string' && type !== 'number') {
    throw new TypeError(`getPipeValue fieldName should be a string or number. Got ${type}`);
  }

  // Allow getPipeValue(pipeString, 'r20');
  if (type === 'string' && fieldName.substring(0, 1) === 'r') {
    const rPipe = processPipe(pipeString);
    return rPipe[fieldName];
  }

  const pipeArray = pipeString.split('|');

  // Allow `getPipeValue(pipeString, 20)`;
  if (type === 'number') {
    return pipeArray[fieldName];
  }

  if (fieldName === PIPE.CLASS_CODE) {
    return pipeArray[22];
  }

  if (fieldName === PIPE.DESCRIPTION) {
    return pipeArray[0];
  }

  if (fieldName === PIPE.ONE_MONTH) {
    return pipeArray[1];
  }

  if (fieldName === PIPE.TWO_MONTH) {
    return pipeArray[2];
  }

  if (fieldName === PIPE.THREE_MONTH) {
    return pipeArray[3];
  }

  if (fieldName === PIPE.FOUR_MONTH) {
    return pipeArray[4];
  }

  if (fieldName === PIPE.FIVE_MONTH) {
    return pipeArray[5];
  }

  if (fieldName === PIPE.SIX_MONTH) {
    return pipeArray[6];
  }

  if (fieldName === PIPE.SEVEN_MONTH) {
    return pipeArray[7];
  }

  if (fieldName === PIPE.EIGHT_MONTH) {
    return pipeArray[8];
  }

  if (fieldName === PIPE.NINE_MONTH) {
    return pipeArray[9];
  }

  if (fieldName === PIPE.TEN_MONTH) {
    return pipeArray[10];
  }

  if (fieldName === PIPE.ELEVEN_MONTH) {
    return pipeArray[11];
  }

  if (fieldName === PIPE.TWELVE_MONTH) {
    return pipeArray[12];
  }

  if (fieldName === PIPE.THIRTEEN_MONTH) {
    return pipeArray[13];
  }

  if (fieldName === PIPE.FOURTEEN_MONTH) {
    return pipeArray[14];
  }

  if (fieldName === PIPE.FIFTEEN_MONTH) {
    return pipeArray[15];
  }

  if (fieldName === PIPE.TITLED) {
    return pipeArray[16];
  }

  if (fieldName === PIPE.BIENNIEL_2ND_YEAR) {
    return pipeArray[17];
  }

  if (fieldName === PIPE.PENALTY) {
    return pipeArray[18];
  }

  if (fieldName === PIPE.INITIAL_FEE_REQUIRED) {
    return pipeArray[19];
  }

  if (fieldName === PIPE.SPECIALITY_PERSONALIZED) {
    return pipeArray[20];
  }

  if (fieldName === PIPE.SERVICE_FEE_VARIABLE || fieldName === PIPE.GROUP_TOTAL) {
    return pipeArray[21];
  }
}

export default getPipeValue;



// WEBPACK FOOTER //
// ./src/modules/getPipeValue.js